
import { EnumHelper } from "./enum.helper";



enum FormFieldTypes {
    Textbox = 1,
    Dropdown = 2,
    RadioButtonList = 3,
    CheckBox = 4,
    CheckBoxList = 5, 
}
    
namespace FormFieldTypes {
    var _textValues={1: {textValue:"Textbox", order:1}, 2: {textValue:"Dropdown", order:2}, 3: {textValue:"RadioButtonList", order:3}, 4: {textValue:"CheckBox", order:4}, 5: {textValue:"CheckBoxList", order:5}, };

    export function getTextValue(value:FormFieldTypes){
        return _textValues[value].textValue; 
    }

    export function getValueList(sort?:boolean):Array<{id:number, label:string}>{
        return EnumHelper.getValueList(<any>_textValues, sort);
    }
}

export {FormFieldTypes}





// WEBPACK FOOTER //
// ./enums/FormFieldTypes.ts